import { IMenu, TPublicationStatus } from 'src/types/menu.types';
import { IMealtime } from 'src/types/mealtimes.types';
import { Control, FieldValues, UseFormRegister, UseFormWatch } from 'react-hook-form';

export interface IPublishVenue {
  name: string;
  venue_id: string;
  is_trial: boolean;
  priceSchemeName: string;
  publicationDate?: Date;
  publicationStatus?: TPublicationStatus;
}

export interface IPublishDestination {
  name: string;
  channel_id: string;
  /**
   * Extension instance backing this channel. Optional because it is unresolvable for an external
   * system with zero or several configured addons — `buildPublishSelection` refuses to publish
   * those rather than guessing an instance.
   */
  extensionInstanceId?: string;
  publicationDate?: Date;
  publicationStatus?: TPublicationStatus;
  venues: IPublishVenue[];
}

export interface IModalProps {
  closeModal?: () => void;
  isOpen: boolean;
  menuId: string;
  menuName: string;
  isTrial?: boolean;
}

export enum PublishSteps {
  Setup = 0,
  Venues = 1,
  Summary = 2,
}

export interface IPublishModalViewProps {
  onBackClick: () => void;
  onContinueClick: () => void;
}

export interface IPublishSetupViewProps {
  control: Control<FieldValues>;
  register: UseFormRegister<FieldValues>;
  watch: UseFormWatch<FieldValues>;
  menuName: string;
  mealtimes: IMealtime[];
  filteredMealtimes: IMealtime[];
  publicationData: IPublishDestination[];
  showSchedule: boolean;
}

export interface IPublishViewProps {
  selectedVenueIds: string[];
  onVenuesChange: (venueIds: string[]) => void;
  publicationData: IPublishDestination[];
  selectedChannelIds: string[];
}

export interface ISelectedDestination extends IPublishModalViewProps {
  channel: string;
  channel_id: string;
  selected: boolean;
  selectedVenues: string[];
}

export interface IAdditionalMenuViewProps extends IPublishModalViewProps {
  selectableMenus: IMenu[];
  isTrial: boolean;
}
